import { styled } from '@linaria/react';

export const ProductsSection = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    overflow: hidden;
`;

export const ProductsContent = styled.div`
    padding: 1rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const ProductsHeader = styled.h4`
    margin: 0 0 0.75rem 0;
    color: #495057;
    font-size: 0.9rem;
    font-weight: 600;
    
    span {
        font-weight: 400;
        color: #6c757d;
        font-size: 0.8rem;
    }
`;

export const LoadingState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    color: #6c757d;
    
    i {
        margin-right: 0.5rem;
        color: #007bff;
    }
`;

export const ErrorState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    color: #dc3545;
    background: #ffebee;
    border: 1px solid #ffcdd2;
    border-radius: 4px;
    
    i {
        margin-right: 0.5rem;
    }
`;

export const EmptyState = styled.p`
    text-align: center;
    color: #6c757d;
    font-style: italic;
    margin: 2rem 0;
`;

export const ProductsTableContainer = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    
    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;

        &:hover {
            background: #a1a1a1;
        }
    }
`;

export const ProductsTable = styled.div`
    display: grid;
    grid-template-columns: 40px 1fr 1fr 1fr 120px;
    gap: 0;
    background: white;
    min-width: 600px;
`;

export const ProductsTableHeader = styled.div`
    display: contents;
`;

export const ProductHeaderCell = styled.div`
    background: rgb(238 238 238);
    padding: 0.5rem 0.75rem;
    font-weight: 600;
    font-size: 0.75rem;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    position: sticky;
    top: 0;
    z-index: 1;
    
    &:last-child {
        border-right: none;
    }
    
    &.icon-header {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
`;

export const ProductRow = styled.div`
    display: contents;
    cursor: pointer;
    
    &:hover > div {
        background-color: #f8f9fa;
    }
`;

export const ProductCell = styled.div`
    padding: 0.4rem 0.75rem;
    border-bottom: 1px solid #e9ecef;
    border-right: 1px solid #e9ecef;
    display: flex;
    align-items: center;
    transition: background-color 0.15s ease;
    font-size: 0.8rem;
    
    &:last-child {
        border-right: none;
    }
    
    &.icon-cell {
        padding: 0.25rem;
        justify-content: center;
        
        .marpol-icon {
            width: 20px;
            height: 20px;
            object-fit: contain;
        }
    }
    
    &.product-name-cell {
        .product-name {
            font-weight: 500;
            color: #495057;
        }
    }
`;

export const PaginationContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 0;
    margin-top: 0.5rem;
    border-top: 1px solid #e9ecef;
    flex-wrap: wrap;
    gap: 0.5rem;
`;

export const PaginationInfo = styled.span`
    font-size: 0.75rem;
    color: #6c757d;
`;

export const PaginationControls = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    span {
        font-size: 0.75rem;
        color: #495057;
        padding: 0 0.5rem;
    }
`;

export const PaginationButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: white;
    color: #495057;
    cursor: pointer;
    transition: all 0.15s ease;
    
    &:hover:not(:disabled) {
        background: #f8f9fa;
        border-color: #007bff;
        color: #007bff;
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const PageSizeSelect = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    label {
        font-size: 0.875rem;
        color: #6c757d;
    }
    
    select {
        padding: 0.25rem 0.5rem;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        font-size: 0.875rem;
        color: #495057;
        background: white;
        cursor: pointer;
        
        &:focus {
            outline: none;
            border-color: #007bff;
        }
    }
`;